// Libs
import React, { ReactElement } from 'react';
// App
import styles from 'app-shared/lib/layout/shared/header/header.module.scss';

import MainNav from './main-nav';
import Brand from 'app-shared/lib/layout/shared/header/brand';
import { Gutter } from 'app-shared/lib/layout/shared/gutter';
import { useAccount } from '@/fragments/_shared/account';
import { SHOP_ADMIN_PAGES_URLS } from '@/fragments/shop-administration/shop-administration.constants';

const Header = (): ReactElement => {
  const { account } = useAccount();
  const shopId = account?.shopId;

  const getHomeUrl = () => {
    if (!shopId) return '/';

    return `${SHOP_ADMIN_PAGES_URLS['shop-details']}?shp_id=${shopId}`;
  };

  return (
    <header className={styles.header}>
      <Gutter className={styles.gutter}>
        <Brand className={styles.brand} url={getHomeUrl()} />
        <MainNav />
      </Gutter>
    </header>
  );
};

export default Header;
